import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {UserImpl} from "../../shared/services/user-impl.service";
import {NotificationService} from '../../shared/services/notification.service';

/**
 * Формат ошибки HTTP-ответа, обрабатываемой перехватчиком.
 * status — код статуса; error — объект с заголовком, деталями и сообщением.
 */
export interface Error {
  status: number,
  error: {
    title: string,
    detail: string,
    message: string
  }
}

/**
 * Перехватчик ошибок HTTP-запросов.
 *
 * Обрабатывает коды 401/500 и прочие: при 401 выполняет выход пользователя и показывает уведомление,
 * при 500 подменяет заголовок и выводит тост. Использует NotificationService для отображения ошибок.
 */
@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {
  private readonly notificationService: NotificationService = inject(NotificationService)
  private readonly userImpl: UserImpl = inject(UserImpl)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        tap({
          error: (err: Error) => {
            switch (err.status) {
              case 401:
                this.userImpl.logout(() => {
                  this.showError(err.error.detail, err.error.title)
                })
                break;
              case 500:
                err.error.title = "Что-то пошло не так"
                this.showError(err.error.detail, err.error.title)
                break;
              default:
                this.showError(err.error.detail, err.error.title)
                break;
            }
          }})
      )
  }

  private showError(message: string, title: string): void {
    this.notificationService.danger(message, title)
  }
}
